import { TestSurface } from './types';

export const TESTS = {
  'woo-cart-in-navigation': {
    variants: {
      control: 80, // 80% of users will see the old behavior
      test: 20 // 50% of users will see the new behavior
    },
    controlVariant: 'control',
    testSurfaces: [TestSurface.OOV4, TestSurface.CUSTOM_DOMAINS],
    disabled: false
  }
};
